import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import { AgGridReact } from "@ag-grid-community/react";
import PRHLoader from '../../lib/PRHLoader';
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");
import "../MainBox.css";
import NotesPopUpUS from "./NotesPopUp-US";

export default function NotesUS(props) {
    const [noteId, setNoteId] = useState(0);
    const [noteTooltip, setNoteTooltip] = useState('');
    const [toolTipId, setToolTipId] = useState(0);
    const [openPopup, setOpenPopup] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [rowDataLoading, setRowDataLoading] = useState(false);
    const [searchNoteText, setSearchNoteText] = useState(null);
    const [isSearchedData, setIsSearchedData] = useState(false);
    const [noteComments, setnoteComments] = useState("");
    const [updateStatus, setUpdateStatus] = useState(null); // State to track update status
    const debounceTimer = useRef(null);

    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        popupParent: document.body,
        animateRows: true,
        accentedSort: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        suppressRowClickSelection: true,
        // onGridReady: (event) => event.api.sizeColumnsToFit(),

    }
    const onGridReady = (params) => {

        const allColumnIds = params.columnApi
            .getAllDisplayedColumns()
            .map((col) => col.getColId());
        params.columnApi.autoSizeColumns(allColumnIds);
    };

    const columnDefs = [
        {
            headerName: "Create Date", field: "createDate", headerClass: "HeaderClassSource header-text-right",
            width: 70,
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            },
            /*    tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Author", field: "userName", headerClass: "HeaderClassSource",
            width: 100,
            cellClass: "CellClassSource-left-align",
            /*    tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Visibility", field: "visibility", headerClass: "HeaderClassSource",
            width: 50,
            cellClass: "CellClassSource cell-text-left",
            /*    tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Status", field: "status", headerClass: "HeaderClassSource",
            width: 50,
            cellClass: "CellClassSource cell-text-left",
            /*          tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Priority", field: "priority", headerClass: "HeaderClassSource",
            width: 50,
            cellClass: "CellClassSource cell-text-left",
            /*   tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Note", field: "note", headerClass: "HeaderClassSource",

            cellClass: "CellClassSource-left-align",
            valueFormatter: (params) => {
                const value = params.value || "";
                return value.length > 100 ? value.substring(0, 100) + "..." : value;
            }
            /*cellRenderer: (params) => {

                return <div className="note-container">
                    <span>{params.value}</span>
                    {*//*<i onMouseEnter={() => callNote(id)}
                        title={toolTipId == id ? noteTooltip :"Loading..."}   className="fa fa-info-circle fa-lg info-icon-note"></i>*//*}

                </div >;
            },*/
        },
        {
            headerName: "", field: "", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource-left-align",
            tooltipValueGetter: (params) => {
                return params.data?.note;
            },
            cellRenderer: (params) => {
                return <div className="note-container">

                    <button className="ISBNSubmit mr-1" >Preview</button>

                </div >;
            },
        },
    ]

    const callNote = (id) => {


        clearTimeout(debounceTimer.current); // Clear previous timeout
        debounceTimer.current = setTimeout(async () => {
            getNotes(id);
        }, 500); // 300ms debounce delay}

    }

    const getNotes = async (id) => {
        try {
            if (id > 0 && toolTipId != id) {

                const data = await apiHelper.inventoryPostCall("getNotes", { value: id });
                if (data) {
                    setNoteTooltip(data.note);
                    setToolTipId(id);
                } else {
                    setNoteTooltip('No Data Available');
                    setToolTipId(0);
                }
            }
        } catch (e) {
            console.error("get note for tootip failed", e);
        }
    }



    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }
    const handleNoteChange = (e) => {

        setnoteComments(e.target.value);
    };
    const handleNoteBlur = async () => {
        if (noteComments?.length > 500) {
            setUpdateStatus({ success: false, message: "Note exceeds 500 characters" });
            return; // Do not update if the combined note exceeds 500 characters
        }

        try {
            await apiHelper.inventoryPostCall("setInventoryNote", { isbn: props.metaData.isbn, values: noteComments });
            setUpdateStatus({ success: true, message: "Inventory Note updated successfully" });
        } catch (error) {
            console.error("Failed to update inventory comment", error);
            setUpdateStatus({ success: false, message: "Failed to update note" });
        } finally {
            setTimeout(() => setUpdateStatus(null), 3000);
        }
    };

    const onRowClicked = async (event) => {
        const data = JSON.stringify(event.data.noteID);
        setNoteId(data);
        setOpenPopup(true);
    };
    const closePopUp = () => {
        setOpenPopup(false);
    }
    const newPopup = () => {
        setNoteId(0);
        setOpenPopup(true);
    }
    const getShortNotes = async (loadAll) => {
        try {
            setRowDataLoading(true);
            setRowData([]);
            setIsSearchedData(!loadAll);
            if (loadAll) {
                setSearchNoteText(null);
            }

            if (!props.ISBNId || props.ISBNId.trim().length == 0) {
                return;
            }
            var res = await apiHelper.inventoryPostCall("getShortNotes", {
                ISBN: props.ISBNId,
                RequestUPN: props.upn,
                SearchText: loadAll ? null : searchNoteText
            });
            if (res != undefined && res != null) {
                setRowData(res);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setRowDataLoading(false);
        }
    }
    const clearSearch = () => {
        setSearchNoteText(null);
        getShortNotes(true);
    }

    useEffect(() => {
        getShortNotes(true);
        if (props.metaData) {
            setnoteComments(props?.metaData?.inventoryNote ?? "");
        } else {
            setnoteComments("");
        }
    }, [props.metaData])


    return (<>
        <div className="notes-container container-fluid">
            <div className="short-notes">

                <Row>
                    <Col>
                        <Form.Group>
                            {(rowDataLoading || props.isMetaLoading) && <PRHLoader></PRHLoader>}
                            <Form.Label>ZMUP Comments</Form.Label>
                            <input className='custom-input left-p-input width100Per'
                                value={props.metaData != null && props.metaData != undefined ? props.metaData?.zmupComment1 : ''} disabled></input>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Inventory Note</Form.Label>
                            {(props.isEditable && props?.metaData.access === 'm') ?
                                <textarea
                                    rows="5"
                                    className='custom-input left-p-input width100Per mb-1'
                                    maxLength="500"
                                    value={noteComments}
                                    onChange={handleNoteChange}
                                    onBlur={handleNoteBlur}
                                    disabled={!props.isEditable}
                                    style={{ height: 'auto' }}
                                />
                                :
                                <input className='custom-input left-p-input width100Per'
                                    value={props.metaData != null && props.metaData != undefined ? props.metaData?.inventoryNote : ''} disabled></input>}
                            {updateStatus && (
                                <div className={` ${updateStatus.success ? 'success' : 'error'}`} role="alert">
                                    {updateStatus.message}
                                </div>
                            )}
                        </Form.Group>

                    </Col>
                </Row>

                <Row className="search-bar">
                    <Col>
                        <button className="ISBNSubmit ml-3"
                            disabled={!props.ISBNId || props.ISBNId?.trim().length == 0 || props?.metaData.access != 'm'}
                            onClick={newPopup}>Add New Note</button>
                    </Col>
                    <Col className="search-input">
                        <input type='text'
                            className="custom-input"
                            id='searchText' name='searchText'
                            placeholder='Search notes'
                            value={searchNoteText || ''}
                            disabled={!props.ISBNId || props.ISBNId?.trim().length == 0}
                            onChange={(e) => setSearchNoteText(e.target.value)}
                            onKeyDown={(e) => { if (e.key.toLowerCase() == 'enter') { getShortNotes(false); } }}
                        />
                        <button className="ISBNSubmit ml-3"
                            disabled={!searchNoteText || searchNoteText.trim() == 0 || !props.ISBNId || props.ISBNId?.trim().length == 0}
                            onClick={() => getShortNotes(false)}
                        >Search</button>
                        <button className="ISBNSubmit ml-3"
                            disabled={!isSearchedData || !props.ISBNId || props.ISBNId?.trim().length == 0}
                            onClick={clearSearch}
                        >Clear</button>
                    </Col>
                </Row>

                {rowData && rowData.length > 0 ? <div className="custom mb-1" style={{ height: "180px" }}>

                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        rowSelection="single"
                        onRowClicked={onRowClicked}
                        gridOptions={gridOptions}
                        onGridReady={onGridReady}
                    />
                </div>
                    :
                    <></>}

            </div>
            <NotesPopUpUS
                open={openPopup}
                noteID={noteId}
                ISBNId={props.ISBNId}
                upn={props.upn}
                onClose={closePopUp}
                onSave={getShortNotes}
                isEditable={props.isEditable && props?.metaData.access === 'm'}
            />
        </div>
    </>);
}